var render = function render(){
  var _vm$projectUsers, _vm$projectUsers2, _vm$projectUsers3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: {
      wrapper: true,
      disabled: _vm.disabled
    }
  }, [_c('div', {
    staticClass: "table-title"
  }, [_vm._v(" " + _vm._s(_vm.$t('users')) + " "), _c('span', {
    staticClass: "user-count"
  }, [_vm._v(_vm._s((_vm$projectUsers = _vm.projectUsers) === null || _vm$projectUsers === void 0 ? void 0 : _vm$projectUsers.length))])]), _c('div', {
    attrs: {
      "id": "itemList"
    }
  }, [(_vm$projectUsers2 = _vm.projectUsers) !== null && _vm$projectUsers2 !== void 0 && _vm$projectUsers2.length ? _c('b-table', {
    staticClass: "mb-0 table",
    attrs: {
      "items": _vm.itemsForList,
      "fields": _vm.getFields,
      "busy": _vm.loading,
      "responsive": "",
      "primary-key": "id",
      "tbody-tr-class": "rowClass"
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function () {
        return [_c('div', {
          staticClass: "text-center text-primary my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle",
          attrs: {
            "variant": "primary"
          }
        }), _c('strong', [_vm._v(_vm._s(_vm.$t('loading')))])], 1)];
      },
      proxy: true
    }, {
      key: "head(role)",
      fn: function (data) {
        return [_c('span', [_vm._v(_vm._s(data.label))]), _c('img', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          staticClass: "ml-2 mb-1",
          attrs: {
            "id": "questionmark",
            "src": require("@/assets/customer-project/questionmark.svg")
          },
          on: {
            "mouseover": function ($event) {
              _vm.hover = true;
            },
            "mouseleave": function ($event) {
              _vm.hover = false;
            }
          }
        }), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.hover,
            expression: "hover"
          }]
        }, [_c('div', {
          staticClass: "tooltipp"
        }, [_vm._v(" " + _vm._s(_vm.$t('customer-project.roles')) + " "), _vm._l(_vm.types, function (type) {
          return _c('div', {
            key: type.id
          }, [_c('img', {
            attrs: {
              "src": require(`@/assets/customer-project/${type.value.toLowerCase()}.svg`)
            }
          }), _vm._v(" " + _vm._s(type.name) + " ")]);
        })], 2)])];
      }
    }, {
      key: "cell(name)",
      fn: function (row) {
        return [_c('span', {
          staticClass: "table-name"
        }, [_vm._v(_vm._s(row.item.name))]), row.item.role === 'ADMINISTRATOR' ? _c('img', {
          staticClass: "ml-1 mb-1",
          attrs: {
            "src": require("@/assets/customer-project/administrator.svg")
          }
        }) : _c('img', {
          staticClass: "ml-1 mb-1",
          attrs: {
            "src": require("@/assets/customer-project/editor.svg")
          }
        })];
      }
    }, {
      key: "cell(role)",
      fn: function (row) {
        return [_vm.canEditProjectUserRole(row.item) ? _c('form-selector', {
          staticClass: "project-table-control",
          attrs: {
            "options": _vm.types
          },
          on: {
            "change": function ($event) {
              return _vm.onChange($event, row.item.id);
            }
          },
          model: {
            value: row.item.role,
            callback: function ($$v) {
              _vm.$set(row.item, "role", $$v);
            },
            expression: "row.item.role"
          }
        }) : _c('span', [_vm._v(" " + _vm._s(_vm.$t(`customer-project.role.type.${row.item.role}`)) + " ")])];
      }
    }, {
      key: "cell(event)",
      fn: function (row) {
        return [row.item.role !== 'ADMINISTRATOR' ? _c('project-table-event-selector', {
          staticClass: "project-table-control",
          attrs: {
            "options": _vm.getOptions,
            "selected-event-ids": _vm.getEventIds(row.item.id)
          },
          on: {
            "on-select": function ($event) {
              return _vm.onSelectEvent($event, row.item.id);
            },
            "on-remove": function ($event) {
              return _vm.onRemoveEvent($event, row.item.id);
            }
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(actions)",
      fn: function (row) {
        var _vm$profile;
        return [row.item.id !== ((_vm$profile = _vm.profile) === null || _vm$profile === void 0 ? void 0 : _vm$profile.id) ? _c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal",
            value: `remove-user-modal${row.item.id}`,
            expression: "`remove-user-modal${row.item.id}`"
          }],
          staticClass: "button"
        }, [_c('img', {
          attrs: {
            "src": require("@/assets/customer-project/delete.svg"),
            "alt": "delete"
          }
        })]) : _vm._e(), _c('confirmation-modal', {
          attrs: {
            "id": `remove-user-modal${row.item.id}`,
            "variant": "danger",
            "yes-key": "delete"
          },
          on: {
            "on-click-yes": function ($event) {
              return _vm.onRemove(row.item.id);
            }
          },
          scopedSlots: _vm._u([{
            key: "body-text",
            fn: function () {
              return [_c('img', {
                staticClass: "modal-icon",
                attrs: {
                  "src": require("@/assets/customer-project/danger.svg")
                }
              }), _c('h2', {
                staticClass: "modal-title"
              }, [_vm._v(" " + _vm._s(_vm.$t('customer-project.modal.delete.title')) + " ")]), _c('p', {
                staticClass: "modal-p"
              }, [_vm._v(" " + _vm._s(_vm.$t('customer-project.modal.delete.body')) + " "), _c('strong', [_vm._v(" " + _vm._s(`${row.item.firstName} ${row.item.lastName}`) + " ")])])];
            },
            proxy: true
          }], null, true)
        })];
      }
    }], null, false, 1998517609)
  }) : _vm._e(), _c('div', {
    staticClass: "pagination-container"
  }, [_c('b-pagination', {
    staticClass: "pegination mb-0",
    attrs: {
      "total-rows": (_vm$projectUsers3 = _vm.projectUsers) === null || _vm$projectUsers3 === void 0 ? void 0 : _vm$projectUsers3.length,
      "per-page": _vm.perPage,
      "aria-controls": "itemList",
      "align": "right",
      "limit": "5",
      "hide-goto-end-buttons": ""
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  }, [_c('template', {
    slot: "prev-text"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/customer-project/prev.svg")
    }
  }), _vm._v(" " + _vm._s(_vm.$t('prev')) + " ")]), _c('template', {
    slot: "next-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('next')) + " "), _c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/customer-project/next.svg")
    }
  })])], 2)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }